module.exports = __webpack_public_path__ + "static/media/IMG_1410.3a8f12c9.JPG";